<ngx-ui-loader>
</ngx-ui-loader>
<app-toast-custom></app-toast-custom>

<router-outlet></router-outlet>


<p-confirmDialog header="Atenção!" [rejectVisible]="false" acceptLabel="OK"
    icon="pi pi-exclamation-triangle"></p-confirmDialog>